import { useState, useEffect } from "react"
import { ISexo, SexoKeys } from "../../../../../../../application/models"
import { useRecortesExtracaoService } from "../../../../../../../use-cases/geo-veles"
import { useUIService } from "../../../../../../../use-cases/ui"
import { Autocomplete, Button, Grid, TextField } from "@mui/material"
import { sexoKeyToLabel } from "../../../detalhes-do-projeto/filtros/sexo"
// Icon
import AddIcon from '@mui/icons-material/Add'
import { useAppSelector } from "../../../../../../hooks/store-hooks"

export const RecorteSexo = () => {
    // State
    const { createRecorteExtracaoForm } = useAppSelector((state) => state.recorteExtracao)

    // Use State
    const [selectedSexo, setSelectedSexo] = useState<ISexo[]>([])

    // Hook
    const { syncFilterWithForm, removeFilterFromForm, resetSelectedFilter } = useRecortesExtracaoService()
    const { setAlert } = useUIService()

    useEffect(() => {
        const sexosSelecionados = createRecorteExtracaoForm.fields.Filtros?.sexo || [];

        if (sexosSelecionados.length > 0) {
            setSelectedSexo(sexosSelecionados);
        } else {
            setSelectedSexo([]);
        }
    }, [createRecorteExtracaoForm.fields.Filtros?.sexo]);

    // Filtra as opções para remover os itens já selecionados
    const filteredSexos = SexoKeys.filter((sexo: ISexo) =>
        !selectedSexo.some((selected: ISexo) => selected === sexo)
    );

    // Functions
    const handleAddSexoFilter = () => {
        if (selectedSexo.length > 0) {
            syncFilterWithForm({
                filtro: 'sexo',
                value: selectedSexo,
                formType: 'create'
            })
            resetSelectedFilter()
        } else {
            setAlert({
                message: 'Selecione ao menos um sexo',
                type: 'error'
            })
        }
    }

    const handleSexoSelectionChange = (value: ISexo[]) => {
        setSelectedSexo(value);

        if (value.length > 0) {
            syncFilterWithForm({
                filtro: 'sexo',
                value: value,
                formType: 'create'
            });
        } else {
            removeFilterFromForm({
                filtro: 'sexo',
                formType: 'create'
            });
        }
    }

    return (
        <>
            <Grid item xs={11} my={2}>
                <Autocomplete
                    multiple
                    id="tags-standard"
                    options={filteredSexos}
                    getOptionLabel={(option) => sexoKeyToLabel(option).toUpperCase()}
                    sx={{
                        px: 2
                    }}
                    value={selectedSexo}
                    onChange={(event, value) => {
                        handleSexoSelectionChange(value);
                    }}
                    noOptionsText='Nenhum sexo encontrado'
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            label="Opções"
                        />
                    )}
                />
            </Grid>
            <Grid item xs={1} my={2}>
                <Button
                    color="primary"
                    fullWidth
                    onClick={handleAddSexoFilter}
                    endIcon={<AddIcon color="primary" />}
                />
            </Grid>
        </>
    )
}